export default __webpack_public_path__ + "static/media/ff-logo-white.3d213701.png";